export enum DialogActions {
  DISABLE_USER = 'disableSelectedUser',
  DELETE_USER = 'deleteSelectedUser'
}

export enum DialogMessages {
  DISABLE_USER = 'Are you sure you want to DISABLE the user?',
  DELETE_USER = 'Are you sure you want to DELETE the user?'
}
